/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */
import { TwoColumns } from '../../post/styles'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`En esta sección vamos a aprender como agregar imágenes, iconos, ilustraciones vectoriales o cualquier otro tipo de imágenes dentro de nuestros componentes.`}</p>
    <p>{`Dentro de la Pokédex utilizaremos dos archivos `}<em parentName="p">{`.gif`}</em>{` que nos ayudaran a mostrar en la pantalla de la Pokédex el estado de carga y error mientras hacemos una petición a la `}<em parentName="p">{`PokeAPI`}</em>{`.`}</p>
    <TwoColumns mdxType="TwoColumns">
  <img src="/images/pokedex/pokedex-error.png" alt="Error Pokédex Error" />
  <img src="/images/pokedex/pokedex-loading.png" alt="Error Pokédex Preview" />
    </TwoColumns>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;